import { render } from "./SexyPrice.vue?vue&type=template&id=09e4c4e6"
import script from "./SexyPrice.vue?vue&type=script&lang=js"
export * from "./SexyPrice.vue?vue&type=script&lang=js"

import "./SexyPrice.vue?vue&type=style&index=0&id=09e4c4e6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__